import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { FormNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FilterDetailList, FiltersLeadIn, hasFilters, Times, Within } from '../condition-parts';

type FormConditionProps = { node: FormNode };

export function FormCondition({ node }: FormConditionProps) {
  const operator = node.inverse ? 'not submitted' : 'submitted';
  return (
    <ConditionViewerItem
      icon={getIconForNode(node)}
      details={hasFilters(node.filters) ? <FilterDetailList filters={node.filters} /> : undefined}
    >
      <ConditionViewerTerm>{node.formName ?? 'form'}</ConditionViewerTerm> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <FiltersLeadIn filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionViewerItem>
  );
}
